import React from 'react';

import { motion, AnimatePresence } from 'framer-motion';

import { DrawerResizeHandle, useDrawerResize } from '@/new/components/drawers/drawer-resize';

interface DrawerProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  hideCloseButton?: boolean;
}

export function Drawer({ isOpen, onClose, children, hideCloseButton = false }: DrawerProps) {
  const { width, isResizing, handleMouseDown } = useDrawerResize('right');

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-40 bg-gray-500"
            onClick={onClose}
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className={`fixed top-0 right-0 z-50 h-full border-l ${isResizing ? 'border-teal-400' : 'border-gray-400'} bg-white shadow-lg transition-colors duration-300`}
            style={{ width: `${width}px` }}
          >
            <DrawerResizeHandle side="right" isResizing={isResizing} onMouseDown={handleMouseDown} />

            {!hideCloseButton && (
              <button
                onClick={onClose}
                className="absolute top-4 right-4 cursor-pointer border-none bg-transparent text-2xl"
              >
                &times;
              </button>
            )}

            <div className="h-full">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
